import React from 'react';

export default function search() {
  return (
    <svg width="19" height="19" viewBox="0 0 19 19" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.55176 0.490234C10.1416 0.490234 13.0518 3.40038 13.0518 6.99023C13.0518 8.60023 12.4618 10.0802 11.4918 11.2202L11.7618 11.4902H12.5518L17.5518 16.4902L16.0518 17.9902L11.0518 12.9902V12.2002L10.7818 11.9302C9.64176 12.9002 8.16176 13.4902 6.55176 13.4902C2.96191 13.4902 0.0517578 10.5801 0.0517578 6.99023C0.0517578 3.40038 2.96191 0.490234 6.55176 0.490234ZM6.55176 2.49023C4.05176 2.49023 2.05176 4.49023 2.05176 6.99023C2.05176 9.49023 4.05176 11.4902 6.55176 11.4902C9.05176 11.4902 11.0518 9.49023 11.0518 6.99023C11.0518 4.49023 9.05176 2.49023 6.55176 2.49023Z"
        fill="currentColor"
      />
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="18"
        height="18"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.55176 0.490234C10.1416 0.490234 13.0518 3.40038 13.0518 6.99023C13.0518 8.60023 12.4618 10.0802 11.4918 11.2202L11.7618 11.4902H12.5518L17.5518 16.4902L16.0518 17.9902L11.0518 12.9902V12.2002L10.7818 11.9302C9.64176 12.9002 8.16176 13.4902 6.55176 13.4902C2.96191 13.4902 0.0517578 10.5801 0.0517578 6.99023C0.0517578 3.40038 2.96191 0.490234 6.55176 0.490234ZM6.55176 2.49023C4.05176 2.49023 2.05176 4.49023 2.05176 6.99023C2.05176 9.49023 4.05176 11.4902 6.55176 11.4902C9.05176 11.4902 11.0518 9.49023 11.0518 6.99023C11.0518 4.49023 9.05176 2.49023 6.55176 2.49023Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0)" />
    </svg>
  );
}
